import { forwardRef } from 'react';
import styled from '@emotion/styled';
import { emptyObject } from '@constants/empty';
import useWindowSize from '@hooks/useWindowSize';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import PostCard from './PostCard';
import TestCard from './TestCard';
import { CARD_TYPE } from './constants';

const Wrapper = styled.div`
  .schedule-card-ele:last-child {
    margin-bottom: 0;
  }
  margin-bottom: ${Spacings.SPACING_10B};

  ${mediaQuery.uptoMobile} {
    margin-bottom: ${Spacings.SPACING_6B};
  }
`;

const Date = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const ScheduleCard = forwardRef(
  (
    {
      cardsInfo,
      showSaveIcon,
      hasSkuAccess,
      isSubscribed,
      collectionUid,
      isCbt
    },
    ref
  ) => {
    const { isMobile } = useWindowSize();

    const getDateString = () => {
      const { isFeatured, isLive } = cardsInfo?.cards?.[0] ?? emptyObject;
      if (isFeatured) {
        if (isLive) {
          return `Ongoing - ${cardsInfo.date}`;
        }
        return `Upcoming - ${cardsInfo.date}`;
      }
      return cardsInfo.date;
    };

    return (
      <Wrapper>
        <Date variant={isMobile ? 'h5' : 'h4'}>{getDateString()}</Date>
        {cardsInfo.cards.map((cardInfo, index) => {
          const isLastCard = cardsInfo?.cards?.length - 1 === index;
          if (cardInfo.type === CARD_TYPE.QUIZ) {
            return (
              <TestCard
                className="schedule-card-ele"
                key={cardInfo.uid}
                testInfo={cardInfo}
                showSaveIcon={showSaveIcon}
                isCbt={isCbt}
                ref={isLastCard ? ref : null}
              />
            );
          }
          return (
            <PostCard
              className="schedule-card-ele"
              key={cardInfo.uid}
              postInfo={cardInfo}
              hasSkuAccess={hasSkuAccess}
              isSubscribed={isSubscribed}
              showSaveIcon={showSaveIcon}
              collectionUid={collectionUid}
              ref={isLastCard ? ref : null}
            />
          );
        })}
      </Wrapper>
    );
  }
);

ScheduleCard.displayName = 'ScheduleCard';

export default ScheduleCard;
